/**
 * Handler for the barcode "scan" icon in the New Product / Edit Product forms.
 *
 * On a desktop Admin Dashboard there is no camera scanner — barcode readers are
 * connected as USB keyboard-wedge devices that type the scanned code into the
 * focused field. Clicking the barcode icon must therefore focus (and select) the
 * barcode input so the next scan lands in it. Without this, the icon was a no-op.
 *
 * Returns `true` when an element was focused, `false` when there was nothing to
 * focus — exposed so the behaviour is unit-testable without a DOM environment.
 */
export function focusBarcodeInput(el: HTMLInputElement | null): boolean {
  if (!el) return false;
  el.focus();
  el.select();
  return true;
}
